import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1a829ad8&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a829ad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a829ad8')) {
      api.createRecord('1a829ad8', component.options)
    } else {
      api.reload('1a829ad8', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=1a829ad8&scoped=true", function () {
      api.rerender('1a829ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/structuredInterview/Main.vue"
export default component.exports